import o from "./closeIndex.ce.vue2.js";
import r from "./closeIndex.ce.vue3.js";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ t(o, [["styles", [r]]]);
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/close-form/closeIndex.ce.vue.js
// module id = 1228
// module chunks = 67